export default __webpack_public_path__ + "static/media/03.8c3fda01.png";